var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 " + _vm.size + " " + _vm.size,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M22.6093 10.7693L17.2307 5.39067C16.9807 5.1406 16.6416 5.00008 16.288 5H6.33333C5.97971 5 5.64057 5.14048 5.39052 5.39052C5.14048 5.64057 5 5.97971 5 6.33333V21.6667C5 22.0203 5.14048 22.3594 5.39052 22.6095C5.64057 22.8595 5.97971 23 6.33333 23H21.6667C22.0203 23 22.3594 22.8595 22.6095 22.6095C22.8595 22.3594 23 22.0203 23 21.6667V11.712C22.9999 11.3584 22.8594 11.0193 22.6093 10.7693ZM9.33333 6.33333H13.3333V8.66667H9.33333V6.33333ZM18.6667 21.6667H9.33333V18.6667H18.6667V21.6667ZM21.6667 21.6667H20V18C20 17.8232 19.9298 17.6536 19.8047 17.5286C19.6797 17.4036 19.5101 17.3333 19.3333 17.3333H8.66667C8.48986 17.3333 8.32029 17.4036 8.19526 17.5286C8.07024 17.6536 8 17.8232 8 18V21.6667H6.33333V6.33333H8V9.33333C8 9.51014 8.07024 9.67971 8.19526 9.80474C8.32029 9.92976 8.48986 10 8.66667 10H14C14.1768 10 14.3464 9.92976 14.4714 9.80474C14.5964 9.67971 14.6667 9.51014 14.6667 9.33333V6.33333H16.288L21.6667 11.712V21.6667Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-231df605", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231df605","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/play_control/save.vue
// module id = null
// module chunks = 